import { db, getLocalChanges, getDeletedOids } from '../db';
import { getCurrentUser } from '../auth';
import { apiBaseUrl } from '../Globals';

export const getLastSyncTime = async () => {
    const setting = await db.settings.get({ key: `last_sync` });
    return setting?.value || 0;
};

export const setLastSyncTime = async (timestamp) => {
    await db.settings.put({ key: `last_sync`, value: timestamp });
};

export const doAllSync = async (ignoreLastSyncDate = false) => {
    const user = getCurrentUser();

    if (!isOnline() || !user?.hash) return;

    const tables = [
        'athletes',
        'shooting',
        'event',
    ];
    const userHash = await user.hash;
    let localChanges = {};
    let deletedIds = {};

    let lastSync = 0;
    if (!ignoreLastSyncDate) {
        lastSync = await getLastSyncTime();
    }

    for (const table of tables) {
        localChanges[table] = await getLocalChanges(table, lastSync);
        // deletedIds[table] = await getDeletedOids(table);
    };

        // Push local changes to server
        const response = await fetch(`${apiBaseUrl}?tx_biathlonhub_api[action]=syncUpload`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-User-Hash': userHash,
            },
            body: JSON.stringify({
                updated: localChanges,
                deleted: deletedIds,
            })
        });

        if (!response.ok) {
           return;
        }


        const { serverData, idMap } = await response.json();

        console.log(response)
        return;

        // // Apply server changes locally
        // await applyServerData(table, serverData, idMap);
        //
        // // Update sync timestamp
        // await updateGlobalLastSyncTime(Date.now());

    console.log('✅ Sync complete');
};

export const isOnline = () => navigator.onLine;
//
// let isRunning = false;
// const SYNC_DELAY = 10 * 1000; // 10 seconds
//
// const SYNC_KEY = 'nextSync';
// const SYNC_QUERY = 'syncQueue';
//
// // Helper: get current queued tables
// const getQueuedTables = () => {
//     const raw = localStorage.getItem(SYNC_QUERY);
//     if (!raw) return [];
//     return raw.split(',').filter(Boolean);
// };
//
// // Helper: save updated queue
// const setQueuedTables = (queue) => {
//     localStorage.setItem(SYNC_QUERY, queue.join(','));
// };
//
// // ✅ Call this function when a sync for a table is needed
// export const requestSync = (table, force = false) => {
//     const now = Date.now();
//     const next = Number(localStorage.getItem(SYNC_KEY) || 0);
//
//     if ((force && !isRunning) || (now >= next && !isRunning)) {
//         localStorage.setItem(SYNC_KEY, now + SYNC_DELAY);
//         runSyncNow(table.split(','));
//     } else {
//         // Add to queue
//         const current = getQueuedTables();
//         table.split(',').forEach((tableItem) => {
//             if (!current.includes(tableItem)) {
//                 current.push(tableItem);
//                 setQueuedTables(current);
//             }
//         })
//
//         // Make sure something will eventually run after 10s
//         setTimeout(() => {
//             tryRunQueuedSync();
//         }, SYNC_DELAY + 100); // small buffer
//     }
// };
//
// const tryRunQueuedSync = () => {
//     const now = Date.now();
//     const next = Number(localStorage.getItem(SYNC_KEY) || 0);
//     const queued = getQueuedTables();
//
//     if (queued.length === 0 || now < next || isRunning) return;
//
//     runSyncNow(queued);
//     localStorage.setItem(SYNC_KEY, now + SYNC_DELAY);
//     setQueuedTables([]);
// };
//
// // ✅ Actual sync logic (uses your existing sync functions)
// export const runSyncNow = async (tables = []) => {
//     if (isRunning) return;
//     isRunning = true;
//
//     try {
//         console.log("[SYNC] Starting sync for:", tables.join(', '));
//
//         let toSync = [];
//         if (tables.includes('athletes')) {
//             toSync.push(syncAthletes());
//         }
//         if (tables.includes('events')) {
//             toSync.push(syncEvents());
//         }
//
//         if (toSync.length > 0) {
//             await Promise.all(toSync);
//
//             window.dispatchEvent(new CustomEvent('serverSync', {
//                 tables: toSync
//             }));
//         }
//
//         let toSync2 = [];
//         if (tables.includes('shooting')) {
//             toSync2.push(syncShooting());
//         }
//         if (tables.includes('event_athletes')) {
//             toSync2.push(syncEventAthletes());
//         }
//
//         if (toSync2.length > 0) {
//             await Promise.all(toSync2);
//             window.dispatchEvent(new CustomEvent('serverSync', {
//                 tables: toSync2
//             }));
//         }
//
//         console.log("[SYNC] Finished.");
//     } catch (e) {
//         console.error("[SYNC] Error:", e);
//     } finally {
//         isRunning = false;
//     }
// };
//
//
//
//
// export const deleteFromServerData = async (row) => {
//     switch (row.tablename){
//         case 'tx_biathlonhub_domain_model_athlete':
//             await deleteAthleteByOid(Number(row.oid));
//             break;
//         case 'tx_biathlonhub_domain_model_shooting':
//             await deleteShootingByOid(Number(row.oid));
//             break;
//         case 'tx_biathlonhub_domain_model_event':
//             await deleteEventByOid(Number(row.oid));
//             break;
//         case 'tx_biathlonhub_domain_model_event_athletes':
//             await deleteEventAthleteByOid(Number(row.oid));
//             break;
//     }
// };
// const asyncSync = async () => {
//     await Promise.all([
//         syncAthletes(),
//         syncEvents()
//     ]);
// };
// const asyncSync2 = async () => {
//     await Promise.all([
//         syncShooting(),
//         syncEventAthletes()
//     ]);
// };